import useSWR from 'swr';
import { fetchEndpointData } from '@/utils/fetch.client';
import { UserRole } from '@/api-models/UserRole';

export interface AdminUser {
  id: string;
  email: string;
  name: string;
  role: string;
  created_at: string;
  last_seen_at: string;
}

interface ListUsersResponse {
  users: AdminUser[];
  total: number;
}

export interface AdminUsersQuery {
  search?: string;
  page: number; // 1-indexed
  pageSize: number;
}

function buildKey({ search, page, pageSize }: AdminUsersQuery) {
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  params.set('limit', String(pageSize));
  params.set('offset', String((page - 1) * pageSize));
  return `/api/v1/admin/users?${params.toString()}`;
}

export function useAdminUsers(query: AdminUsersQuery) {
  const key = buildKey(query);
  const { data, mutate, isLoading, error } = useSWR(key, () => fetchEndpointData<ListUsersResponse>(key), {
    keepPreviousData: true,
  });
  return {
    users: data?.users ?? [],
    total: data?.total ?? 0,
    mutate,
    isLoading,
    error,
  };
}

export async function updateUserRole(userId: string, role: UserRole) {
  return fetchEndpointData<AdminUser>(`/api/v1/admin/users/${encodeURIComponent(userId)}/role`, {
    method: 'PUT',
    body: { role },
  });
}
